'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrLogosCarousel = function () {
  function PrLogosCarousel(el) {
    (0, _classCallCheck3.default)(this, PrLogosCarousel);

    var context = { context: el };

    this.els = {
      el: el,
      slides: (0, _functional.getElement)('.sec-Icons_Items', context)
    };

    this.logosPerSlide = parseInt(this.els.el.dataset.logosPerSlide, 4);
    this.autoplayIntervalSeconds = parseInt(this.els.el.dataset.autoplayInterval, 10) || 0;
    this.carousel = null;
    this.autoplayInterval = null;

    this.currentBreakpoint = window.innerWidth < _utils.mediaBreakpoints.md ? 'sm' : 'md';
    window.addEventListener('resize', this.updateCarousel.bind(this));
    this.updateCarousel();
  }

  (0, _createClass3.default)(PrLogosCarousel, [{
    key: 'updateCarousel',
    value: function updateCarousel() {
      var viewportWidth = window.innerWidth;
      var newBreakpoint = viewportWidth < _utils.mediaBreakpoints.md ? 'sm' : 'md';

      if (newBreakpoint !== this.currentBreakpoint) {
        window.location.reload();
      }

      this.currentBreakpoint = newBreakpoint;

      if (viewportWidth < _utils.mediaBreakpoints.md && !this.carousel) {
        this.carousel = new _siema2.default({
          selector: this.els.slides,
          duration: 500,
          loop: true,
          perPage: 2
        });
        // Start autoplay
        this.startAutoplay();
      } else if (viewportWidth >= _utils.mediaBreakpoints.md && this.carousel) {
        this.carousel.destroy();
        this.carousel = null;

        // Stop autoplay
        this.stopAutoplay();
      }
    }
  }, {
    key: 'startAutoplay',
    value: function startAutoplay() {
      var _this = this;

      // Stop any existing autoplay interval
      this.stopAutoplay();

      // Only start autoplay if autoplayIntervalSeconds is greater than 0
      if (this.autoplayIntervalSeconds > 0) {
        this.autoplayInterval = setInterval(function () {
          _this.carousel.next();
        }, this.autoplayIntervalSeconds * 1000);
      }
    }
  }, {
    key: 'stopAutoplay',
    value: function stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }]);
  return PrLogosCarousel;
}();

exports.default = PrLogosCarousel;